import { render, staticRenderFns } from "./NumbersModal.vue?vue&type=template&id=66160bf7&scoped=true&"
import script from "./NumbersModal.vue?vue&type=script&lang=js&"
export * from "./NumbersModal.vue?vue&type=script&lang=js&"
import style0 from "./NumbersModal.vue?vue&type=style&index=0&id=66160bf7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66160bf7",
  null
  
)

export default component.exports